<template>
  <div>Hello world!</div>
</template>

<script>

export default {
  name: "SetupLeagueGame",
  components: {

  }
}

</script>

<style lang="css" scoped></style>